import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const dls = {
    jpath: ['spectra', 'dls'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default dls;
//# sourceMappingURL=dls.js.map